export default "__VITE_ASSET__644f39c2__"